import React, { useContext, useEffect, useState } from "react";
import { IMAGES } from "../../assets";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { EbookInfo, GetHighlightText } from "../../api";
import { AuthContext } from "../../context";
import { AutoComplete, Input } from "antd";
import { t } from "i18next";
import { STRINGS } from "../../constants";

const HighlightDetails = () => {
  const [highlights, setHighlights] = useState([]);
  const location = useLocation();
  const { user } = useContext(AuthContext);
  const [bookInfo, setBookInfo] = useState();
  const [search, setSearch] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [autoData, setAutoData] = useState();

  const bookPdfItem = location?.state?.bookPdfItem;
  async function getHighlightedText() {
    const params = {
      userId: user?.userInfo?._id,
      bookId: bookPdfItem?._id,
    };
    setIsLoading(true);
    const result = await GetHighlightText(params);
    const datahilight = [];
    result.data.data?.map((item) => {
      datahilight.push(item.HighlightText);
      setHighlights(item.HighlightText);
      const newdata = item.HighlightText.map((item) => {
        return {
          label: item?.comment?.text,
          value: item?.comment?.text,
        };
      });
      setAutoData(newdata);
    });

    setIsLoading(false);
  }

  async function getBookInfo() {
    try {
      const result = await EbookInfo(bookPdfItem?._id);
      setBookInfo(result?.data?.body[0]);
    } catch (err) {
      console.error(err);
    }
  }

  useEffect(() => {
    getHighlightedText();
    if (bookPdfItem) {
      getBookInfo();
    }
  }, []);

  const handleSearch = (value) => {
    setSearch(value);
  };
  const onSelect = (value) => {
    setSearch(value);
  };
  const navigate = useNavigate();
  return (
    <div className="bg-white border p-4 rounded-2xl">
      <div className="">
        <div>
          <div className="my-4 flex items-start justify-start gap-4">
            <button
              className="w-8 h-8 text-lg font-bold border-slate-400 border flex items-center justify-center rounded-full"
              onClick={() => navigate(-1)}
            >
              <img
                className="w-full h-full"
                alt="backarrow"
                src={IMAGES?.backIcon}
              />
            </button>
            <div className="flex items-center justify-between w-full">
              <div className="flex flex-col sm:flex-col sm:items-start sm:gap-1">
                <p className="text-lg font-semibold">{bookInfo?.bookName}</p>
                <p className="text-sm font-medium">{bookInfo?.authorName}</p>
              </div>
              <div className="w-full hidden">
                <AutoComplete
                  className="w-full"
                  onFocus={(e) => {}}
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  options={autoData}
                  onSelect={onSelect}
                  onSearch={handleSearch}
                >
                  <Input
                    size="lg"
                    placeholder={t(STRINGS.search)}
                    className="w-full"
                  ></Input>
                </AutoComplete>
              </div>
            </div>
          </div>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {highlights?.map((ele, index) => (
            <div
              key={index}
              className="p-3 relative border bg-white rounded-2xl h-40 flex flex-col items-start justify-between w-full"
            >
              <div className="flex-grow">
                <p className="text-base font-semibold mb-2">
                  Highlight {index + 1}
                </p>
                <p
                  className="text-ellipsis overflow-hidden"
                  style={{
                    display: "-webkit-box",
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: "vertical",
                    height: "auto",
                  }}
                  title={`${ele?.comment?.text} ${ele?.comment?.emoji}`}
                >
                  {ele?.comment?.text} {ele?.comment?.emoji}
                </p>
              </div>
              <div className="flex items-center justify-between w-full mt-auto">
                <p className="text-sm">Page No: {ele?.position?.pageNumber}</p>
                <button
                  onClick={() =>
                    navigate(`/readbook/${bookPdfItem?.bookName}`, {
                      state: {
                        bookPdfItem: bookInfo,
                        pageNum: ele?.position?.pageNumber,
                      },
                    })
                  }
                  className="px-4 py-1 bg-[#FE6B01] text-white text-base font-medium rounded-xl"
                >
                  View
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default HighlightDetails;
